module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1249.96f4183d.png";